module.exports = __webpack_public_path__ + "img/media-1.d027a4f8.jpg";